
import React from 'react';
import { CANVAS_WIDTH, CANVAS_HEIGHT } from './config/dimensions';

interface GameCanvasProps {
  canvasRef: React.RefObject<HTMLCanvasElement | null>;
  style?: React.CSSProperties;
}

export const GameCanvas: React.FC<GameCanvasProps> = ({ canvasRef, style }) => (
  <canvas 
    ref={canvasRef} 
    width={CANVAS_WIDTH} 
    height={CANVAS_HEIGHT} 
    style={{ 
        backgroundColor: "#000", 
        imageRendering: 'pixelated', // Keep sprites crisp when scaled
        ...style 
    }} 
  />
);
